module.exports = __webpack_public_path__ + "static/media/banner_TeenPattiJoker-half.88e1f023.png";